export default class GraphicObject {

	_gl = null;
	_object = null;

	constructor(gl, object) {
		this._gl = gl;
		this._object = object;
	}

	getContext() {
		return this._gl;
	}

	getObject() {
		return this._object;
	}

	release() {
		this._gl = null;
		this._object = null;
	}

}
